var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { ReactElementFactory } from "../../element-factory";
import { SurveyElementBase } from "../../reactquestion_element";
var MatrixRow = /** @class */ (function (_super) {
    __extends(MatrixRow, _super);
    function MatrixRow(props) {
        var _this = _super.call(this, props) || this;
        _this.root = React.createRef();
        _this.onPointerDownHandler = function (event) {
            _this.parentMatrix.onPointerDown(event.nativeEvent, _this.model.row);
        };
        return _this;
    }
    Object.defineProperty(MatrixRow.prototype, "model", {
        get: function () {
            return this.props.model;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MatrixRow.prototype, "parentMatrix", {
        get: function () {
            return this.props.parentMatrix;
        },
        enumerable: false,
        configurable: true
    });
    MatrixRow.prototype.getStateElement = function () {
        return this.model;
    };
    MatrixRow.prototype.componentDidMount = function () {
        _super.prototype.componentDidMount.call(this);
        if (this.root.current) {
            this.model.setRootElement(this.root.current);
        }
    };
    MatrixRow.prototype.componentWillUnmount = function () {
        _super.prototype.componentWillUnmount.call(this);
        this.model.setRootElement(undefined);
    };
    MatrixRow.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        if (!_super.prototype.shouldComponentUpdate.call(this, nextProps, nextState))
            return false;
        if (nextProps.model !== this.model) {
            if (nextProps.element) {
                nextProps.element.setRootElement(this.root.current);
            }
            if (this.model) {
                this.model.setRootElement(undefined);
            }
        }
        return true;
    };
    MatrixRow.prototype.render = function () {
        var model = this.model;
        if (!model.visible)
            return null;
        return (React.createElement("tr", { ref: this.root, className: model.className, "data-sv-drop-target-matrix-row": model.dropTargetId }, this.props.children));
    };
    return MatrixRow;
}(SurveyElementBase));
export { MatrixRow };
ReactElementFactory.Instance.registerElement("sv-matrix-row", function (props) {
    return React.createElement(MatrixRow, props);
});
